import { createFileRoute } from "@tanstack/react-router";
import { CATEGORY_PILLARS } from "@/data/category-pillars";
import { CategoryPillarPage, categoryPillarJsonLd } from "@/components/CategoryPillarPage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const pillar = CATEGORY_PILLARS.legal;

export const Route = createFileRoute("/legal/")({
  head: () => {
    const url = `${SEO_SITE}/legal`;
    return {
      meta: [
        { title: ctaTitle(pillar.metaTitle, "/legal", "th")},
        { name: "description", content: ctaDesc(pillar.metaDesc, "/legal", "th")},
        { property: "og:title", content: ctaTitle(pillar.metaTitle, "/legal", "th")},
        { property: "og:description", content: ctaDesc(pillar.metaDesc, "/legal", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/legal")],
      scripts: categoryPillarJsonLd(pillar, url),
    };
  },
  component: () => <CategoryPillarPage pillar={pillar} />,
});
